import React from 'react';
import StatsCard from '../../components/dashboard/StatsCard';
import CustomerMap from '../../components/dashboard/CustomerMap';
import TotalRevenue from '../../components/dashboard/TotalRevenue';

const AdminDashboard = () => {
    return (
        <div className=" space-y-6">
            {/* Stats Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
                <StatsCard
                    icon="/assets/statscard/order.svg"
                    value="75"
                    label="Total Orders"
                    percentage="4%"
                    percentageTextColor="text-green-500"
                    iconBg="bg-green-100"
                />

                <StatsCard
                    icon="/assets/statscard/delivered.svg"
                    value="357"
                    label="Total Delivered"
                    percentage="4%"
                    percentageTextColor="text-green-500"
                    iconBg="bg-green-100"
                />

                <StatsCard
                    icon="/assets/statscard/canceled.svg"
                    value="65"
                    label="Total Canceled"
                    percentage="25%"
                    percentageTextColor="text-red-500"
                    iconBg="bg-green-100"
                />

                <StatsCard
                    icon="/assets/statscard/revenue.svg"
                    value="$128"
                    label="Total Revenue"
                    percentage="12%"
                    percentageTextColor="text-red-500"
                    iconBg="bg-green-100"
                />
            </div>

            {/* Charts */}
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 gap-4">
                <CustomerMap />
                <TotalRevenue />
            </div>
        </div>
    );
};

export default AdminDashboard; 